import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Project} from '../../shared/models/project';
import {Size} from '../../shared/models/size';
import {SizeRange} from '../../shared/models/sizeRange';
import {Subscription} from "rxjs";

@Component({
    selector: 'mbnm-choose-size-dialog',
    templateUrl: './choose-size-dialog.component.html',
    styleUrls: ['./choose-size-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChooseSizeDialogComponent implements OnInit, OnDestroy {

  public mode = 'FULL';
  public title = 'Choose a Size';
  public project: Project;
  public selectedSize: any;
  public currentSelection: string;
  public standardSelectionMade = false;
  public standardSizeFilterList: Array<any>;
  public maxCustomSize: any;
  public projectSizeChangeSubRef: Subscription;

  ngOnInit() {
    this.currentSelection = this.selectorType === 'ALL' || this.selectorType === 'CUSTOM' ? 'CUSTOM' : 'STANDARD';

    if (this.currentSelection === 'CUSTOM') {
      this.project = new Project({});

      if (this.maxCustomSize) {
        this.project.size.widthRange = new SizeRange(this.project.size.widthRange.min, this.maxCustomSize[0], this.project.size.widthRange.step);
        this.project.size.heightRange = new SizeRange(this.project.size.heightRange.min, this.maxCustomSize[1], this.project.size.heightRange.step);
      }

      this.selectedSize = {
        outer: [this.project.size.width, this.project.size.height]
      };

      this.projectSizeChangeSubRef = this.project.size.change.subscribe( (size:Size) => {
        this.selectedSize = {
          outer: [size.width, size.height]
        };

        if (this.maxCustomSize) {
          this.project.size.widthRange = new SizeRange(this.project.size.widthRange.min, this.maxCustomSize[0], this.project.size.widthRange.step);
          this.project.size.heightRange = new SizeRange(this.project.size.heightRange.min, this.maxCustomSize[1], this.project.size.heightRange.step);
        }
      });
    }
  }

  selectionChanged(selectedSize) {
    this.standardSelectionMade = true;
    this.selectedSize = selectedSize;
  }

  get showOpeningSizes(): boolean {
    return this.mode && this.mode.split('-')[0] === 'BOTH';
  }

  get selectorType(): string {
    return this.mode ? this.mode.split('-')[1] : null;
  }

  get showCustomSelector(): boolean {
    return this.selectorType === 'CUSTOM' || this.selectorType == 'ALL';
  }

  get showStandardSelector(): boolean {
    return this.selectorType !== 'CUSTOM';
  }

  get oneSelectorOnly(): boolean {
    return (this.showCustomSelector ? 1 : 0) + (this.showStandardSelector ? 1 : 0) === 1;
  }

  constructor() {
  }

  ngOnDestroy() {
    if (this.projectSizeChangeSubRef && !this.projectSizeChangeSubRef.closed) {
      this.projectSizeChangeSubRef.unsubscribe();
    }
  }
}
